import permissions from "app/permissions";
import { SpecialistServicePath } from "utils/constants";
import SchoolIcon from "@mui/icons-material/School";
import EnrollmentOptions from "./EnrollmentOptions";
import { tenants } from "utils/tenants";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <SchoolIcon />,
  name: SpecialistServicePath + "enroll/specialists",
  custom: <EnrollmentOptions />,
  title: "Записване специализанти",
  permission: permissions.canEnrollSpecialists,
};
